import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './index.less';
export var UITextarea = function (props) {
    var View = useComponents().View;
    var style = props.style, className = props.className, value = props.value, placeholder = props.placeholder, maxLength = props.maxLength, defaultValue = props.defaultValue, disabled = props.disabled, onChange = props.onChange;
    return (React.createElement(View, { className: styles['textarea-container'] },
        React.createElement("textarea", { value: value, defaultValue: defaultValue, placeholder: placeholder, maxLength: maxLength, className: className, style: style, disabled: disabled, onChange: onChange })));
};
